import React from "react";

//Helpers
import { getFilteredTOrdersByDateRangeFromLocalTimeStrings } from "../../Helpers/orderFunctions";

//UI material
import { Box } from "@mui/material";

//React-chartjs-2
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartsJS,
  CategoryScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
} from "chart.js";
import { evstations } from "../../Helpers/productSelector";

ChartsJS.register(
  CategoryScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function AllProductsMonthlyProductionGraph({
  data = [],
  year,
  product,
}) {
  //Function to select only the valid order according to product category
  const selectValidOrders = () => {
    switch (product) {
      case "estaciones":
        return data.filter((order) => evstations.includes(order.productName));
      case "accesorios":
        return data.filter((order) => !evstations.includes(order.productName));
      case "todos":
        return data;
      default:
        return data;
    }
  };

  //Function to get the orders
  const extractedInfo = getFilteredTOrdersByDateRangeFromLocalTimeStrings(
    selectValidOrders(),
    `1/1/${year}`,
    `12/31/${year}`,
    "finishedAt"
  );
  const selectProductLabel = () => {
    switch (product) {
      case "estaciones":
        return "Estaciones de carga";
      case "accesorios":
        return "Accesorios";
      case "todos":
        return "Productos";
      default:
        return "Productos";
    }
  };

  //Function to generate graph datasets
  const generateDataSets = () => {
    let products = [
      {
        label: selectProductLabel(),
        data: new Array(12).fill(0),
        backgroundColor: new Array(12).fill("#000"),
        borderColor: new Array(12).fill("#000"),
        tension: 0.2,
      },
    ];

    //Fill order objects iterating trough orders
    for (const { productsStatus, productName } of extractedInfo) {
      for (const product of productsStatus) {
        try {
          const month = new Date(product.finishedAt).getMonth();

          //Validate month
          if (!isNaN(Number(month))) {
            if (productName === "Estación Tipo Wallbox doble") {
              products[0].data[month] += 2;
            } else {
              products[0].data[month] += 1;
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
    }

    products[0].borderColor[new Date().getMonth()] = "#00B4B4";
    products[0].backgroundColor[new Date().getMonth()] = "#00B4B4";

    return products;
  };

  //Function to generate chart data
  const generateChartData = () => ({
    datasets: generateDataSets(),
    labels: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Oct",
      "Nov",
      "Dic",
    ],
  });

  //Function to generate chart options
  const generateChartOptions = () => ({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: { beginAtZero: true },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: false,
      },
    },
  });

  return (
    <Box sx={{ minHeight: "250px" }}>
      <Bar options={generateChartOptions()} data={generateChartData()} />
    </Box>
  );
}
